import { Box, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
import { rows } from './../MastersFakeDb';
import { editDeleteAccountManager, editDeleteCpd, getAccountManagerList, getCpdList } from "../../../actions/actions";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import customerProductMasterService from "../../../services/masters/customerProductMaster.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";


const CpdList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;


    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);
    const totalCount = useSelector(state => state.cpd.total_count || 0);
    const defaultRowsPerPage = useSelector(state => state.cpd.rows_per_page || 15);
    // const rows = useSelector(state => state.cpd.cpd)
    const [rows, setRows] = useState([])
    const [searchKey, setSearchKey] = useState('');

    // Fields and Labels for Excel Export
    const fields = [
        "customer",
        "so_no",
        "issued_by",
        "approved_by",
        "delivery_by",
        "total_credit_limit",
        "gross_amount",
    ];
    const labels = [
        "Customer",
        "Sales Order No",
        "Issued By",
        "Approved By",
        "Delivery By",
        "Total Credit Limit",
        "Gross Amount",
    ];
    //const [successMessage, setSuccessMessage] = useState(null);
    //const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.charges.message);
    const [total_count, setTotalCount] = useState(null)
    useEffect(() => {
        setTotalCount(rows[0]?.totalCount);
    }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage
    });
    useEffect(() => {
        setController(prev => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };
    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await customerProductMasterService.getCpdList(params);
            setRows(response);
        } catch (error) {
            setSuccessMessage("Error fetching data");
        }
    };


    // const handleSearch = (e) => {
    //     setSearchKey(e.target.value)
    //     const params = {
    //         page: controller.page,
    //         size: e.target.value === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
    //         searchKey: e.target.value,
    //     }
    //     dispatch(getCpdList(params))
    // }
    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);  // Set the search key

        // Prepare the params based on the search value
        const params = {
            page: controller.page,
            size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: searchValue,
        };

        try {
            // Fetch data using the fetchData function (assuming fetchData is already declared)
            await fetchData(params);
        } catch (error) {
            console.error("Error in handleSearch:", error);
        }
    };

    useEffect(() => {
        fetchData()
    }, [controller]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);



    const deleteRecord = async (id) => {
        try {
            await customerProductMasterService.editDeleteCpd({
                cpd_id: id,
                changedUpdatedValue: "delete"
            });
            setIsDelete(false);
            fetchData();
            setSuccessMessage("Record deleted successfully");
        } catch (error) {
            setSuccessMessage("Error deleting record");
        }
    };

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };

    // Sort rows by entry_date descending
    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
    // Calculate pagination info
     const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

    console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });




    const [successMessage, setSuccessMessage] = useState(null);
    //const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.cpd.message);

    // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData,null, setSuccessMessage, respMsgState);
    //      useEffect(() => {
    //             if (respMsgState) {
    //                 setSuccessMessage(respMsgState);
    //             }
    //         }, [respMsgState]);
    //     useEffect(() => {
    //     }, [shouldShowMsg, responseMessage,]);

    return (
        <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
            <Box className={`${styles.body}`}>
                <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'Customer Product Details List' },
                    ]}
                />




                <HeaderSection
                    title="Customer Product Details List"
                    addNewPath="/masters/add-cpd"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Customer Product Details List"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />


                <Paper sx={{ width: '100%', }}>
                    <TableContainer
                        component={Paper}
                        className={`${styles.list_tbl_container}`}
                    >
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell sx={{ width: '30%' }} align="left" className={`${styles.table_head}`} onClick={() => HandleSort('cust_name', sortBy, setSortBy, rows)}>Customer Name<span className={`${styles.sort_icon}`}> {sortBy === 'cust_name' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort('prod_code', sortBy, setSortBy, rows)}>Prod Code<span className={`${styles.sort_icon}`}> {sortBy === 'prod_code' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => HandleSort('rate', sortBy, setSortBy, rows)}>Rate<span className={`${styles.sort_icon}`}> {sortBy === 'rate' ? '▲' : '▼'} </span></StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>

                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.map((row, index) => (
                                    <StyledTableRow
                                        key={row.name}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >

                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cust_name}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.prod_code}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.rate}</StyledTableCell>
                                        <StyledTableCell align="center" >
                                            <CustomePopover row={row}     handleCancel={false} handleDelete={false} linkTo="/masters/add-cpd" handlePrint={false} />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                     {/* <TablePagination
                      rowsPerPageOptions={[10, 25, 100]}
                      component="div"
                      count={total_count || 0}
                      rowsPerPage={controller.rowsPerPage}
                      page={controller.page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
                    <CustomPagination
                              page={controller.page}
                              rowsPerPage={controller.rowsPerPage}
                              totalCount={total_count || 0}
                              onPageChange={(newPage) => handleChangePage(null, newPage)}
                            />
                </Paper>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.cpd_id || null}
                    displayName={deleteInfo?.cpd_id || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    )
}
export default CpdList;